import { render, staticRenderFns } from "./WorkflowForm.vue?vue&type=template&id=7c5895f1"
import script from "./WorkflowForm.vue?vue&type=script&lang=js"
export * from "./WorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./WorkflowForm.vue?vue&type=style&index=0&id=7c5895f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports